function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u6392\\u5217\\u9806\\u5E8F",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(2.000000, -1.400000)",
  fill: "#555555"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(1.000000, 11.500000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.65807804,1.07425516 C9.13519561,0.849794264 9.68799074,0.827348174 10.1802438,1.00691689 L10.341899,1.07425516 L17.9487431,4.65290997 C18.9039694,5.10229808 19.2958954,6.23161719 18.7581861,7.14309624 C18.6090813,7.39584609 18.3996989,7.60759593 18.1501508,7.76383556 L17.9957629,7.85080204 L17.095674,6.06478971 C17.0765735,6.07441569 17.0546746,6.09454561 17.0355952,6.12688729 C16.9687625,6.24017654 17.001221,6.37739963 17.0638451,6.43875124 L17.0973509,6.46264237 L9.5,2.887 L1.90262615,6.46264237 C1.91456835,6.45702413 1.92792879,6.44701401 1.94118393,6.43198462 L1.96079724,6.40559767 C2.03045421,6.29537318 2.0015898,6.15516112 1.93843854,6.09039657 L1.90430306,6.06478971 L1.0042142,7.85080204 C0.0602703648,7.37508677 -0.295939437,6.23286265 0.270106935,5.33715661 C0.426529331,5.0896354 0.641548548,4.88445892 0.894833651,4.73545846 L1.05123397,4.65290997 L8.65807804,1.07425516 Z",
  id: "Path",
  fillRule: "nonzero",
  transform: "translate(9.500066, 4.369003) scale(1, -1) translate(-9.500066, -4.369003) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.65807804,5.07425516 C9.13519561,4.84979426 9.68799074,4.82734817 10.1802438,5.00691689 L10.341899,5.07425516 L17.9487431,8.65290997 C18.9039694,9.10229808 19.2958954,10.2316172 18.7581861,11.1430962 C18.6090813,11.3958461 18.3996989,11.6075959 18.1501508,11.7638356 L17.9957629,11.850802 L17.095674,10.0647897 C17.0765735,10.0744157 17.0546746,10.0945456 17.0355952,10.1268873 C16.9687625,10.2401765 17.001221,10.3773996 17.0638451,10.4387512 L17.0973509,10.4626424 L9.5,6.887 L1.90262615,10.4626424 C1.91456835,10.4570241 1.92792879,10.447014 1.94118393,10.4319846 L1.96079724,10.4055977 C2.03045421,10.2953732 2.0015898,10.1551611 1.93843854,10.0903966 L1.90430306,10.0647897 L1.0042142,11.850802 C0.0602703648,11.3750868 -0.295939437,10.2328627 0.270106935,9.33715661 C0.426529331,9.0896354 0.641548548,8.88445892 0.894833651,8.73545846 L1.05123397,8.65290997 L8.65807804,5.07425516 Z",
  id: "Path-Copy",
  fillRule: "nonzero",
  transform: "translate(9.500066, 8.369003) scale(1, -1) translate(-9.500066, -8.369003) "
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path-3",
  transform: "translate(1.946935, 1.942683) scale(1, -1) translate(-1.946935, -1.942683) ",
  points: "1 2.88536502 2.89386942 1.9981606 1.80692358 1"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path-3-Copy-2",
  transform: "translate(1.946935, 5.942683) scale(1, -1) translate(-1.946935, -5.942683) ",
  points: "1 6.88536502 2.89386942 5.9981606 1.80692358 5"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path-3-Copy",
  transform: "translate(17.046935, 1.942683) scale(-1, -1) translate(-17.046935, -1.942683) ",
  points: "16.1 2.88536502 17.9938694 1.9981606 16.9069236 1"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path-3-Copy-3",
  transform: "translate(17.046935, 5.942683) scale(-1, -1) translate(-17.046935, -5.942683) ",
  points: "16.1 6.88536502 17.9938694 5.9981606 16.9069236 5"
})), /*#__PURE__*/React.createElement("path", {
  d: "M4.75258434,3.56922618 L13.8377847,6.52003073 C14.1423112,6.61893865 14.3810613,6.85768875 14.4799693,7.16221528 L17.4307738,16.2474157 C17.6013787,16.7726893 17.3138629,17.3368103 16.7885893,17.5074153 C16.6045823,17.5671794 16.4071896,17.5722834 16.2203398,17.5221088 L6.73218444,14.9742592 C6.38751603,14.8817056 6.1182944,14.612484 6.02574077,14.2678156 L3.47789124,4.77966016 C3.33466065,4.24627151 3.65094626,3.69776326 4.1843349,3.55453268 C4.37118467,3.504358 4.56857731,3.50946208 4.75258434,3.56922618 Z M5.887,6.04 L7.807,13.192 L14.959,15.112 L12.734,8.265 L5.887,6.04 Z",
  id: "Rectangle",
  fillRule: "nonzero",
  transform: "translate(10.461690, 10.538321) scale(1, -1) rotate(-45.000000) translate(-10.461690, -10.538321) "
})));

function SvgLayer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u6392\u5217\u9806\u5E8F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer);
export default __webpack_public_path__ + "static/media/layer.4d7fdd1e.svg";
export { ForwardRef as ReactComponent };